export const SeccionPaciente = ({ data }) => {
    const tdStyle = {
        padding: '3px'
    };

    return (
        <>
            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                Datos del Paciente
            </div>
            <table style={{ width: '98%', borderCollapse: 'collapse', marginTop: '5px' }} role='presentation'>
                <tbody>
                    <tr>
                        <td style={{ ...tdStyle, width: '38%' }}><strong>Nombre:</strong>&nbsp;{data?.nombre}</td>
                        <td style={{ ...tdStyle, width: '32%' }}><strong>Apellido:</strong>&nbsp;{data?.apellido}</td>
                        <td style={{ ...tdStyle, width: '30%' }}><strong>Edad:</strong>&nbsp;{data?.edad}</td>
                    </tr>
                    <tr>
                        <td style={{ ...tdStyle }}><strong>Sexo:</strong>&nbsp;{data?.sexo}</td>
                        <td style={{ ...tdStyle }}><strong>Documento:</strong>&nbsp;{data?.tipoDocumento} {data?.numeroDocumento}</td>
                        <td style={{ ...tdStyle }}><strong>Fecha Nacimiento:</strong>&nbsp;{data?.fechaNacimiento}</td>
                    </tr>
                    <tr>
                        <td style={{ ...tdStyle }}><strong>Cobertura:</strong>&nbsp;{data?.cobertura}</td>
                        <td style={{ ...tdStyle }}><strong>Nro. Afiliado:</strong>&nbsp;{data?.numeroAfiliado}</td>
                        <td style={{ ...tdStyle }}><strong>Fecha Ingreso:</strong>&nbsp;{data?.fechaAlta}</td>
                    </tr>
                </tbody>
            </table>
            <table style={{ width: '98%', borderCollapse: 'collapse', borderTop: 'none', borderBottom: 'none', marginTop: '0px' }} role='presentation'>
                <tbody>
                    <tr>
                        <td style={{ width: '50%', ...tdStyle, border: 'none', borderLeft: '1pt solid #818181' }}><strong>Plan Inicial:</strong>&nbsp;{data?.planInicial}</td>
                        <td style={{ width: '50%', ...tdStyle, border: 'none', borderLeft: '1pt solid #818181', borderRight: '1pt solid  #818181' }}><strong>Plan Actual:</strong>&nbsp;{data?.planActual}</td>
                    </tr>
                </tbody>
            </table>
            <table style={{ width: '98%', borderCollapse: 'collapse', marginTop: '0px' }} role='presentation'>
                <tbody>
                    <tr>
                        <td style={{ width: '38%', ...tdStyle }}><strong>Familiar a Cargo:</strong>&nbsp;{data?.familiar}</td>
                        <td style={{ width: '32%', ...tdStyle }}><strong>Teléfono:</strong>&nbsp;{data?.familiarTelefono}</td>
                        <td style={{ width: '30%', ...tdStyle }}><strong>Vínculo:</strong>&nbsp;{data?.vinculo}</td>
                    </tr>
                    <tr>
                        <td style={{ ...tdStyle, }} colSpan={3}><strong>Observaciones:</strong>&nbsp;{data?.informacionAdicional}</td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}